module.exports = __webpack_public_path__ + "static/media/za.7fc34f8b.png";